// @core/api/endpoints/platform/transfer_platform_ownership.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformResponse,
  TransferPlatformOwnershipRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Transfer platform ownership
 * Transfers platform ownership to another member. The current owner relinquishes owner privileges and the new owner gains full administrative control.
 */
export async function TransferPlatformOwnership(
  platform_id: string,
  data: TransferPlatformOwnershipRequest,
  options?: RequestOptions
): Promise<PlatformResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/ownership/transfer`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.post<PlatformResponse>(requestPath, data, requestOptions);
}
